import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetMessage, ILandingContact, ISendMessage, ISearchResult, IPagination } from '../models';
import { PageEndpoint } from '../endpoints/page';

/**
 * ### **ContactService**
 *
 * Un Servicio en Angular es el mecanismo para compartir funcionalidad entre componentes, en este caso se encarga de de compartir las funciones
 * hacen diferentes peticiones o llamados a distintos API's que genera el backend.Algunos componentes que hacen uso de este servicio son:
 *  * {@link ContactComponent}
 */
@Injectable({
  providedIn: 'root',
})
export class Contact {
  private readonly http = inject(HttpClient);

  /**@ignore */
  constructor() {}

  /**
   * Función encargada de obtener la información del landing de contacto, para esto hace uso del servicio de HttpClient y su metodo get.
   */
  contact(): Observable<ILandingContact> {
    return this.http.get<ILandingContact>(PageEndpoint.contact);
  }

  /**
   * Función encargada de enviar la solicitud hecha por el usuario en el formulario PQRD,
   * para esto hace uso del servicio de HttpClient y su metodo post.
   */
  sendMessage(message: ISendMessage): Observable<ISendMessage> {
    console.log(message);
    return this.http.post<ISendMessage>(PageEndpoint.sendMessage, message);
  }

  /**
   * Función encargada de obtener las solicitudes PQRD de un usuario específico,
   * para esto hace uso del servcio de HttpClient y su función get.
   */
  getQuestion(user: string): Observable<Array<IGetMessage>> {
    return this.http.get<Array<IGetMessage>>(PageEndpoint.getQuestions.concat(user));
  }

  /**
   * Función encargada de obtener los datos de la gobernación para la geolocalización de la misma en el mapa,
   * esto lo hace a través del método get del servicio HttpClient.
   */
  idecut(): Observable<IPagination<Array<ISearchResult>>> {
    return this.http.get<IPagination<Array<ISearchResult>>>(PageEndpoint.idecut);
  }
}
